import React from 'react';

import * as ST from './styled';

const PopupError = ({ title, errorText, onErrorRead }) => {
    return (
        <ST.PopupContainer>
            <ST.PopupHeader>{`Подключение услуги «${title}»`}</ST.PopupHeader>

            <ST.Paragraph>
                {errorText}
            </ST.Paragraph>

            <ST.PopupButtonsWrapper>
                <ST.Button
                    width={ST.POPUP_BUTTON_WIDTH}
                    onClick={onErrorRead}
                >
                    Назад
                </ST.Button>
            </ST.PopupButtonsWrapper>
        </ST.PopupContainer>
    );
};

export default PopupError;
